var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-container"},[_c('Header'),_c('transition',{attrs:{"name":"component-fade-route","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }